var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"user-select":"none"},attrs:{"id":"test"}},[_c('div',{ref:"imageWrapper",staticClass:"list",style:({
     transform: 'scale(' + _vm.num + ')',
     position: 'relative',
     width: '300px',
     height: '300px',
   }),on:{"mousedown":_vm.moveMouse}},[_vm._l((_vm.formData.injectionPosition),function(item,index){return _c('div',{directives:[{name:"drag",rawName:"v-drag"}],key:index,ref:'biaozhu' + index,refInFor:true,staticClass:"list1",style:({
       width: item.width + 'px',
       height: item.height + 'px',
       position: 'absolute',
       left: item.left + 'px',
       top: item.top + 'px',
       background: 'rgba(43,100,206,0.3)',

     }),on:{"mousedown":function($event){$event.stopPropagation();return _vm.move($event,index)},"click":function($event){return _vm.handelClick(index)}}},[(index == _vm.divindex)?_c('el-button',{staticClass:"del",staticStyle:{"padding":"1px"},attrs:{"type":"danger","icon":"el-icon-delete"},on:{"click":function($event){return _vm.del(index,$event)}}}):_vm._e()],1)}),_c('div',{staticClass:"list2",style:({
       height: _vm.biaozhuHeight + 'px',
       width: _vm.biaozhuWidth + 'px',
       top: _vm.biaozhuTop + 'px',
       left: _vm.biaozhuLeft + 'px',
       position: 'absolute',
       background: 'rgba(43,100,206,0.3)',
     })}),_c('img',{staticStyle:{"width":"300px","height":"300px","pointer-events":"none"},attrs:{"src":require("../../assets/img/people.png"),"alt":""}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }